import { render, staticRenderFns } from "./MarketplaceServicesViewAll.vue?vue&type=template&id=2fd997f4&scoped=true"
import script from "./MarketplaceServicesViewAll.vue?vue&type=script&lang=js"
export * from "./MarketplaceServicesViewAll.vue?vue&type=script&lang=js"
import style0 from "./MarketplaceServicesViewAll.vue?vue&type=style&index=0&id=2fd997f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd997f4",
  null
  
)

export default component.exports